<template>
  <div id="app">
    <MainComponent></MainComponent>
  </div>
</template>
<script>
import MainComponent from './components/main/index.vue'
export default {
  components: {
    MainComponent
  },
}
</script>
<style lang="scss">
@import './common/common.scss';
@import './common/index.css';
.el-dialog__header {
        display: none !important;
    }
    .el-dialog__body {
        padding: 0 !important;
    }
</style>
